import { LocationDetailsResponse } from '@/core/domain/location-details/models/location-details.model';
import { GetLocationDetailsUseCase } from '@/core/domain/location-details/usecases/getLocationDetails.usecase';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { catchError, throwError } from 'rxjs';

@Component({
    selector: 'fe-location-detail-destination',
    templateUrl: './location-detail-destination.component.html',
    styleUrls: ['./location-detail-destination.component.scss'],
})
export class LocationDetailDestinationComponent implements OnInit {
    public infoServiceVisible = false;

    public locationDetails: LocationDetailsResponse | null = null;

    public addressLocation = '';
    public openHour = '';
    public closeHour = '';

    private code = '';

    @Output() locationDetailsLoaded =
        new EventEmitter<LocationDetailsResponse>();

    constructor(
        private readonly route: ActivatedRoute,
        private readonly getLocationDetailsUseCase: GetLocationDetailsUseCase,
    ) {}

    ngOnInit(): void {
        this.route.paramMap.subscribe((params) => {
            this.code = params.get('code') || '';
            this.getLocationDetails(this.code);
        });
    }

    getLocationDetails(id: string): void {
        this.getLocationDetailsUseCase
            .execute(id)
            .pipe(
                catchError((error) => {
                    this.locationDetailsLoaded.emit(undefined);
                    return throwError(() => error);
                }),
            )
            .subscribe((locationDetails) => {
                this.locationDetails = locationDetails;

                this.locationDetailsLoaded.emit(this.locationDetails);

                const destination = this.locationDetails?.data?.destination;

                if (destination) {
                    this.addressLocation = `${destination.branchName} ${destination.street} ${destination.number}, ${destination.colony}, ${destination.zipCode} ${destination.city}`;

                    this.openHour = destination.openHour
                        ? this.formatTime(destination.openHour)
                        : '';
                    this.closeHour = destination.closeHour
                        ? this.formatTime(destination.closeHour)
                        : '';
                } else {
                    this.addressLocation = '';
                    this.openHour = '';
                    this.closeHour = '';
                }
            });
    }

    toggleInfoService() {
        this.infoServiceVisible = !this.infoServiceVisible;
    }

    formatTime(time: string): string {
        const parts = time.split(':');
        let hour = parseInt(parts[0], 10);
        const minutes = parts[1];
        const ampm = hour >= 12 ? 'PM' : 'AM';
        hour = hour % 12;
        hour = hour ? hour : 12;
        return `${hour}:${minutes} ${ampm}`;
    }
}
